module.exports = __webpack_public_path__ + "img/322.c8940855.jpg";